module.exports = __webpack_public_path__ + "img/caishen_600.3248d13e.png";